/* Stylesheet */

.value_container {
  display: flex;
  justify-content: space-between;
}

.dark {
  color: var(--ion-color-text-secondary);
}

.light {
  color: #869bb9;

  .disabled {
    color: var(--ion-color-text-disabled);
  }
}
